import { InputTextarea } from 'primereact/inputtextarea';
import ButtonEditor from '../../components/button-editor';
import { Controller } from 'react-hook-form';
import { useState, useEffect } from 'react';
import styles from '../../stylesheets/carouselCard.module.css';
import redCrossIcon from '../../../../../assets/svgIcons/redCross.svg';

const MediaCarouselCard = ({ index, control, setValue, removeCard }) => {
  const [templateButtons, setTemplateButtons] = useState([]);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [mediaType, setMediaType] = useState('IMAGE');

  // Sync buttons with react-hook-form
  useEffect(() => {
    setValue(`carouselCards.${index}.buttons`, templateButtons);
  }, [templateButtons, index, setValue]);

  const handleQuickReplyChange = (e, id) => {
    setTemplateButtons((prev) =>
      prev.map((btn) => (btn.id === id ? { ...btn, text: e.target.value } : btn)),
    );
  };

  const handleButtonEdit = (value, id, field) => {
    const newValue = value?.target ? value.target.value : value;

    setTemplateButtons((prev) =>
      prev.map((btn) => (btn.id === id ? { ...btn, [field]: newValue } : btn)),
    );
  };

  const removeButton = (id) => {
    setTemplateButtons((prev) => prev.filter((btn) => btn.id !== id));
  };

  const addQuickReplyBtn = () => {
    setTemplateButtons((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        type: 'QUICK_REPLY',
        text: '',
      },
    ]);
  };

  const handleAddCTA = (type) => {
    setTemplateButtons((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        type,
        text: '',
        url: '',
        phone_number: '',
      },
    ]);
  };

  const getButtonTypeCounts = () => {
    const quickReplyCount = templateButtons.filter((b) => b.type === 'QUICK_REPLY').length;
    const urlCount = templateButtons.filter((b) => b.type === 'URL').length;
    const phoneCount = templateButtons.filter((b) => b.type === 'PHONE_NUMBER').length;

    return {
      total: templateButtons.length,
      quickReplyCount,
      urlCount,
      phoneCount,
      totalCTA: urlCount + phoneCount,
      maxQuickReplies: 2,
      maxURL: 1,
      maxPhone: 1,
    };
  };

  const handleRemoveMedia = (field) => {
    field.onChange(null); // remove from react-hook-form
    setFileInputKey((prev) => prev + 1); // reset input
  };

  return (
    <div className={` ${styles.carouselCard}`}>
      {/* CARD HEADER */}

      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>Card {index + 1}</span>

        {index !== 0 && (
          <img
            src={redCrossIcon}
            alt="Delete"
            className={styles.cardDelete}
            onClick={() => removeCard(index)}
          />
        )}
      </div>
      {/*  */}

      <div className={`${styles.padding}`}>
        <label className={styles.sectionTitle}>Media Type</label>
        <Controller
          name={`carouselCards.${index}.mediaType`}
          control={control}
          defaultValue="IMAGE"
          render={({ field }) => (
            <div className={styles.mediaTypeWrapper}>
              <span
                className={`${styles.mediaType} ${
                  mediaType === 'IMAGE' ? styles.mediaTypeActive : ''
                }`}
                onClick={() => {
                  setMediaType('IMAGE');
                  setValue(`carouselCards.${index}.mediaType`, 'IMAGE');
                  setValue(`carouselCards.${index}.media`, null); // ✅ clear media
                  setFileInputKey((prev) => prev + 1);
                }}
              >
                Image
              </span>

              <span
                className={`${styles.mediaType} ${
                  mediaType === 'VIDEO' ? styles.mediaTypeActive : ''
                }`}
                onClick={() => {
                  setMediaType('VIDEO');
                  setValue(`carouselCards.${index}.mediaType`, 'VIDEO');
                  setValue(`carouselCards.${index}.media`, null); // ✅ clear media
                  setFileInputKey((prev) => prev + 1);
                }}
              >
                Video
              </span>
            </div>
          )}
        />

        {/* MEDIA UPLOAD */}

        <Controller
          name={`carouselCards.${index}.media`}
          control={control}
          render={({ field }) => (
            <div>
              <label className={styles.uploadBox}>
                <input
                  key={fileInputKey}
                  type="file"
                  accept={mediaType === 'IMAGE' ? 'image/*' : 'video/*'}
                  onChange={(e) => field.onChange(e.target.files[0])}
                  className={styles.hiddenInput}
                />

                <div className={styles.browseContainer}>
                  <p className={styles.browse}>Browse Files</p>
                </div>

                <div className={styles.uploadContent}>
                  <i className="pi pi-upload" />

                  <span className={styles.uploadHighlight}>Choose a file</span>
                </div>
              </label>
              {field.value && (
                <div className={styles.previewWrapper}>
                  {field.value.type?.includes('image') && (
                    <div className={styles.previewContainer}>
                      <img
                        src={URL.createObjectURL(field.value)}
                        alt="Preview"
                        className={styles.previewImage}
                      />

                      <img
                        src={redCrossIcon}
                        alt="Remove"
                        className={'mt-2'}
                        onClick={() => handleRemoveMedia(field)}
                      />
                    </div>
                  )}

                  {field.value.type?.includes('video') && (
                    <div className={styles.previewContainer}>
                      <video className={styles.previewVideo} controls>
                        <source src={URL.createObjectURL(field.value)} />
                      </video>

                      <img
                        src={redCrossIcon}
                        alt="Remove"
                        className={styles.removeMediaIcon}
                        onClick={() => handleRemoveMedia(field)}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        />

        {/* CARD TEXT */}
        <p className={` ${styles.sectionTitle}`}>Card Text (Optional)</p>
        <Controller
          name={`carouselCards.${index}.cardText`}
          control={control}
          render={({ field }) => (
            <InputTextarea
              {...field}
              rows={2}
              placeholder="Add a short description"
              className="w-full  mb-3"
            />
          )}
        />

        {/* BUTTON EDITOR */}

        <ButtonEditor
          templateButtons={templateButtons}
          setTemplateButtons={setTemplateButtons}
          handleQuickReplyChange={handleQuickReplyChange}
          handleButtonEdit={handleButtonEdit}
          removeButton={removeButton}
          addQuickReplyBtn={addQuickReplyBtn}
          handleAddCTA={handleAddCTA}
          getButtonTypeCounts={getButtonTypeCounts}
          mode="CAROUSEL"
        />
      </div>
    </div>
  );
};

export default MediaCarouselCard;
